/* eslint-disable import/prefer-default-export */
export const getDateDE = (isoString: string): string => {
  const dateObj = new Date(isoString);
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(dateObj);
};
